import React from "react";
import { Box, Typography } from "@mui/material";

const BerelianHeader = () => {
  return (
    <Box
      component="header"
      sx={{
        position: "relative",
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: {
          xs: "flex-start",
          md: "center",
        },
        px: { xs: 2, sm: 8 },
        pt: 2,
        pb: 2,
        height: 120,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          gap: { xs: 1, sm: 2 },
          right: { xs: 2, sm: 6, lg: 24 },
        }}
      >
        <Box
          component="img"
          src={"/media/logo/pishroLogo.png"}
          alt="logo 1"
          sx={{
            objectFit: "contain",
            width: {
              xs: 80,
              sm: 100,
              lg: 120,
            },
            height: "auto",
          }}
        />

        <Box
          component="img"
          src={"/media/logo/berelianLogo.png"}
          alt="logo 2"
          sx={{
            objectFit: "contain",
            width: {
              xs: 60,
              sm: 80,
              lg: 100,
            },
            height: "auto",
          }}
        />
      </Box>

      <Typography
        sx={{
          color: "#666565",
          fontWeight: 800,
          fontSize: {
            xs: "1.125rem",
            sm: "1.5rem",
            md: "2rem",
          },
        }}
      >
        سامانه پیشرو - برلیان
      </Typography>
    </Box>
  );
};

export default BerelianHeader;
